import { render, staticRenderFns } from "./edit_teammember.vue?vue&type=template&id=07950654&scoped=true&"
import script from "./edit_teammember.vue?vue&type=script&lang=js&"
export * from "./edit_teammember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07950654",
  null
  
)

export default component.exports